import {useUserContext} from '@/components/Providers/UserContext.tsx';
import {useCallback} from 'react';

export class AuthenticatedFetchError extends Error {}

const useAuthenticatedFetch = (): typeof fetch => {
    const {user} = useUserContext();

    return useCallback(
        async (input: RequestInfo | URL, init?: RequestInit) => {
            const modifiedInit = init ?? {};
            modifiedInit.headers = new Headers(modifiedInit.headers);
            modifiedInit.headers.set('Authorization', `Bearer ${user?.id_token}`);

            return await fetch(input, modifiedInit);
        },
        [user?.id_token],
    );
};

export default useAuthenticatedFetch;
